export enum PERMISSION {
  READ_DASHBOARD = 'READ_DASHBOARD',

  BENEFICIARY_TYPE = 'BENEFICIARY_TYPE',
  BENEFICIARY_ALL_READ = 'BENEFICIARY_ALL_READ',
  BENEFICIARY_WORK_HISTORY = 'BENEFICIARY_WORK_HISTORY',
  BENEFICIARY_LOCAL_ELIGIBLE = 'BENEFICIARY_LOCAL_ELIGIBLE',

  BENEFICIARY_READ = 'BENEFICIARY_READ',
  BENEFICIARY_PRINT_PATIENT_FORM = 'BENEFICIARY_PRINT_PATIENT_FORM',
  BENEFICIARY_PRINT_EMERGENCY = 'BENEFICIARY_PRINT_EMERGENCY',

  NSSF_USER = 'NSSF_USER',

  PATIENT_PRINT_FORM_READ = 'PATIENT_PRINT_FORM_READ',
  PATIENT_PRINT_FORM_CLOSE = 'PATIENT_PRINT_FORM_CLOSE',

  CONSUMPTION_READ = 'CONSUMPTION_READ',
  CONSUMPTION_WRITE = 'CONSUMPTION_WRITE',
  CONSUMPTION_APPROVAL = 'CONSUMPTION_APPROVAL',
  CONSUMPTION_DELETE = 'CONSUMPTION_DELETE',

  CLAIM_REQUEST_HOS_READ = 'CLAIM_REQUEST_HOS_READ',
  CLAIM_REQUEST_HOS_WRITE = 'CLAIM_REQUEST_HOS_WRITE',
  CLAIM_REQUEST_HOS_APPROVAL = 'CLAIM_REQUEST_HOS_APPROVAL',
  CLAIM_REQUEST_HOS_DELETE = 'CLAIM_REQUEST_HOS_DELETE',

  CLAIM_REQUEST_NSSF_READ_ALL = 'CLAIM_REQUEST_NSSF_READ_ALL',
  CLAIM_REQUEST_NSSF_READ_ASSIGN_ONLY = 'CLAIM_REQUEST_NSSF_READ_ASSIGN_ONLY',
  CLAIM_REQUEST_NSSF_ASSIGN = 'CLAIM_REQUEST_NSSF_ASSIGN',
  CLAIM_REQUEST_NSSF_APPROVAL = 'CLAIM_REQUEST_NSSF_APPROVAL',
  CLAIM_REQUEST_NSSF_MAKE_PAYMENT = 'CLAIM_REQUEST_NSSF_MAKE_PAYMENT',

  PAYMENT_REQUEST_READ = 'PAYMENT_REQUEST_READ',
  PAYMENT_REQUEST_WRITE = 'PAYMENT_REQUEST_WRITE',
  PAYMENT_REQUEST_APPROVAL = 'PAYMENT_REQUEST_APPROVAL',
  PAYMENT_REQUEST_PRINT = 'PAYMENT_REQUEST_PRINT',

  TRANSMITTAL_LETTER_READ = 'TRANSMITTAL_LETTER_READ',
  TRANSMITTAL_LETTER_WRITE = 'TRANSMITTAL_LETTER_WRITE',
  TRANSMITTAL_LETTER_APPROVAL = 'TRANSMITTAL_LETTER_APPROVAL',
  TRANSMITTAL_LETTER_PRINT = 'TRANSMITTAL_LETTER_PRINT',

  HOSPITAL_REQUEST_READ = 'HOSPITAL_REQUEST_READ',
  HOSPITAL_REQUEST_WRITE = 'HOSPITAL_REQUEST_WRITE',
  HOSPITAL_REQUEST_APPROVAL = 'HOSPITAL_REQUEST_APPROVAL',
  HOSPITAL_REQUEST_DELETE = 'HOSPITAL_REQUEST_DELETE',

  HOSPITAL_PENALTY_READ = 'HOSPITAL_PENALTY_READ',
  HOSPITAL_PENALTY_WRITE = 'HOSPITAL_PENALTY_WRITE',

  HOSPITAL_READ = 'HOSPITAL_READ',
  HOSPITAL_WRITE = 'HOSPITAL_WRITE',

  REGISTER_HOSPITAL_READ = 'REGISTER_HOSPITAL_READ',
  REGISTER_HOSPITAL_WRITE = 'REGISTER_HOSPITAL_WRITE',

  HOSPITAL_CONTRACT_READ = 'HOSPITAL_CONTRACT_READ',
  HOSPITAL_CONTRACT_WRITE = 'HOSPITAL_CONTRACT_WRITE',
  HOSPITAL_CONTRACT_APPROVAL = 'HOSPITAL_CONTRACT_APPROVAL',
  HOSPITAL_CONTRACT_DELETE = 'HOSPITAL_CONTRACT_DELETE',

  HOSPITAL_CONTRACT_CASE_READ = 'HOSPITAL_CONTRACT_CASE_READ',
  HOSPITAL_CONTRACT_CASE_WRITE = 'HOSPITAL_CONTRACT_CASE_WRITE',

  HOSPITAL_USER_READ = 'HOSPITAL_USER_READ',
  HOSPITAL_USER_WRITE = 'HOSPITAL_USER_WRITE',

  PHARMACY_REQUEST_READ = 'PHARMACY_REQUEST_READ',
  PHARMACY_REQUEST_WRITE = 'PHARMACY_REQUEST_WRITE',
  PHARMACY_REQUEST_APPROVAL = 'PHARMACY_REQUEST_APPROVAL',

  PHARMACY_READ = 'PHARMACY_READ',
  PHARMACY_WRITE = 'PHARMACY_WRITE',

  PHARMACY_CONTRACT_READ = 'PHARMACY_CONTRACT_READ',
  PHARMACY_CONTRACT_WRITE = 'PHARMACY_CONTRACT_WRITE',
  PHARMACY_CONTRACT_APPROVAL = 'PHARMACY_CONTRACT_APPROVAL',

  PHARMACY_USER_READ = 'PHARMACY_USER_READ',
  PHARMACY_USER_WRITE = 'PHARMACY_USER_WRITE',

  READ_NSSF_USER = 'READ_NSSF_USER',
  ALLOW_CREATE_NSSF_USER = 'ALLOW_CREATE_NSSF_USER',
  ALLOW_EDIT_NSSF_USER = 'ALLOW_EDIT_NSSF_USER',
  ALLOW_DISABLE_NSSF_USER = 'ALLOW_DISABLE_NSSF_USER',

  READ_SETTING = 'READ_SETTING',
  ALLOW_CREATE_SETTING = 'ALLOW_CREATE_SETTING',
  ALLOW_EDIT_SETTING = 'ALLOW_EDIT_SETTING',
  ALLOW_DISABLE_SETTING = 'ALLOW_DISABLE_SETTING',

  READ_REPORT_PATIENT_FORM = 'READ_REPORT_PATIENT_FORM',
  READ_REPORT_PATIENT_FORM_NSSF = 'READ_REPORT_PATIENT_FORM_NSSF',
  READ_REPORT_HF_PAYMENT = 'READ_REPORT_HF_PAYMENT',
  READ_REPORT_HOSPITAL = 'READ_REPORT_HOSPITAL',
  READ_REPORT_CONSUMPTION = 'READ_REPORT_CONSUMPTION',

  READ_REPORT_BENEFICIARY = 'READ_REPORT_BENEFICIARY',

  HOSPITAL_SERVICE_READ = 'HOSPITAL_SERVICE_READ',
  HOSPITAL_SERVICE_WRITE = 'HOSPITAL_SERVICE_WRITE',
}

export enum SECTION {
  DASHBOARD = 'menu.dashboard',
  DASHBOARD_WORK = 'menu.dashboard',

  VICTIM_LIST = 'menu.victim_list',

  HOSPITAL_REQUEST = 'setting.hospital.hospital_request',
  HOSPITAL = 'menu.hospital',

  HOSPITAL_RESULT = 'setting.hospital.hospital_result',

  HOSPITAL_CONTRACT = 'menu._hospital.hos_contract',

  HOSPITAL_FACILITY_CASEASE = 'menu._hospital.hos_contract_case',

  HOSPITAL_SERVICE = 'menu._hospital.hos_service',

  HOSPITAL_NON_CONTRACT = 'menu._hospital.hos_noncontract',

  HOSPITAL_CONTRACT_CASE = 'menu._hospital.hos_contract_case',

  HOSPITAL_BANK_ACCOUNT = 'menu._hospital.hos_bank_account',

  HOSPITAL_USER = 'menu._hospital.hos_manager',

  HOSPITAL_PENALTY = 'menu._hospital.hos_penalty',

  HOSPITAL_NONCONTRACT = 'menu._hospital.hos_noncontract',

  PHARMACY_REQUEST = 'setting.pharmacy.request',
  PHARMACY = 'setting.pharmacy.title',

  HOSPITAL_CON = 'menu._claim_request.title',
  PAYMENT_CLAIM = 'menu.payment_claim.title',
  PATIENT_PRINT_FORM = 'menu.patient_form',
  HOSPITAL_CON_REQUEST = 'menu.consumption.title',
  HOSPITAL_CON_TRAN_REQUEST = 'menu._claim_request.request',
  HOSPITAL_CON_TRAN_REQUEST_HOS = 'menu._claim_request.request_hos',
  HOSPITAL_CON_TRAN_REQUEST_NSSF = 'menu._claim_request.request_nssf',
  HOSPITAL_CON_ASSIGN_REQUEST = 'menu._claim_request.to_doc',
  HOS_CON_INTERPRETETION = 'menu._claim_request.req_note',
  HOS_TRANSMITTAL_REQUEST = 'menu._claim_request.transmittal_letter',
  POST_PROCESSING = 'menu._claim_request.post_process',
  BENEFICIARY = 'menu.member_ship',

  BENEFICIARY_TYPE = 'menu.beneficiary_type',
  BENEFICIARY_WORK_HISTORY = 'member.working_history.title',
  BENEFICIARY_ALL_READ = 'menu.all_member_ship',
  PHARMACY_RESULT = 'setting.pharmacy.result',

  PHARMACY_CONTRACT = 'menu._pharmacy.phar_contract',

  PHARMACY_USER = 'menu._pharmacy.pharmacy_manager',

  AUTO_APPROVAL = 'menu.auto_approval.auto_approval',
  AUTO_APPROVAL_CONFIGS = 'menu.auto_approval.approval_config',

  AUTO_APPROVAL_AUDITLOGS = 'menu.auto_approval.approval_audit_log',

  NSSF_USER = 'menu.user_admin',

  SETTING = 'menu.setting',

  ALL_REPORT = 'menu.report',
  PATIENT_FORM = 'menu.member_ship',
  REPORT_HF_PAYMENT = 'menu._claim_request.req_note',
  HOSPITAL_REPORT = 'setting.hf_hospital',
  BEN_TYPE = 'menu.beneficiary_type',
  HF_CONSUMPTION = 'menu._claim_request.hf_consumption',
}
